<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert = false"
      :variant="variant"
    >
      {{ alertText }}
    </b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="9" sm="12" class="mt-2">
          <p style="font-size: 17px; color: #2284ab">Upload Documents</p>
          <p></p>
          <div
            style="
              padding: 10px;
              border: 2px solid #c4c6be;
              border-radius: 15px;
            "
          >
            <div class="row mb-2">
              <div class="col-md-12">
                <span
                  class="ln-eng"
                  style="font-size: 0.875rem; color: red"
                  v-if="currentLan == 'eng'"
                  >Upload Scanned Copies of Original Documents. Try to avoid
                  Scanned copy of zeroxed documents.</span
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan == 'mar'"
                  >अर्जदार फोटो * </span
                ><span
                  class="ln-eng"
                  style="font-size: 0.875rem"
                  v-if="currentLan == 'eng'"
                  >Applicant Photo *
                </span>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiPhoto"
                  @change="onFileChange1"
                  v-if="form.UserDocuments.PhotoPath == ''"
                  accept=".jpg, .png, .gif, .JPG, .PGN, .GIF"
                  size="sm"
                  required
                  v-model="Photo"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserDocuments.PhotoPath != ''">
                <a
                  :href="getImgUrl2(form.UserDocuments.PhotoPath)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.PhotoPath)"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2('PhotoPath', form.UserDocuments.PhotoPath)
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan == 'mar'"
                  >अर्जदाराची सही *</span
                ><span style="font-size: 0.875rem" class="ln-eng"
                  >Applicant Signature *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiSign"
                  @change="onFileChange2"
                  v-if="form.UserDocuments.SignaturePath == ''"
                  accept=".jpg, .png, .gif, .JPG, .PGN, .GIF"
                  v-model="Signature"
                  required
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.SignaturePath != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.SignaturePath)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.SignaturePath)"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'SignaturePath',
                      form.UserDocuments.SignaturePath
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan == 'mar'">आधार कार्ड</span
                ><span style="font-size: 0.875rem" class="ln-eng"
                  >Aadhaar Card</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiAdhr"
                  @change="onFileChange3"
                  v-if="form.UserDocuments.AdharCardPath == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="Aadhaar"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.AdharCardPath != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.AdharCardPath)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.AdharCardPath)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'AdharCardPath',
                      form.UserDocuments.AdharCardPath
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan == 'mar'"
                  >रेशन कार्ड (प्रथम आणि अंतिम पृष्ठ) *</span
                ><span style="font-size: 0.875rem" class="ln-eng"
                  >Ration Card (First and Last Page)
                </span>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiRtn"
                  @change="onFileChange4"
                  v-if="form.UserDocuments.RationCardPath == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="rationCard"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.RationCardPath != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.RationCardPath)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.RationCardPath)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'RationCardPath',
                      form.UserDocuments.RationCardPath
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan == 'mar'"
                  >जन्म दिनांक दाखला *</span
                >
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Date Of Birth Certificate/ School Leaving Certificate *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiDob"
                  @change="onFileChange5"
                  v-if="form.UserDocuments.BirthCertificate == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="dob"
                  required
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.BirthCertificate != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.BirthCertificate)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.BirthCertificate)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'BirthCertificate',
                      form.UserDocuments.BirthCertificate
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>

            <br />

            <div class="row" v-if="getUserCat">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan == 'mar'"
                  >जात प्रमाणपत्र *</span
                ><span style="font-size: 0.875rem" class="ln-eng"
                  >Caste Certificate *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiCst"
                  @change="onFileChange6"
                  v-if="form.UserDocuments.CasteCertificate == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="Caste"
                  required
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.CasteCertificate != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.CasteCertificate)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.CasteCertificate)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'CasteCertificate',
                      form.UserDocuments.CasteCertificate
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan == 'mar'"
                  >सर्वोच्च डिग्री प्रमाणपत्र *</span
                ><span style="font-size: 0.875rem" class="ln-eng"
                  >Highest Degree Certificate *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiEdu"
                  @change="onFileChange7"
                  v-if="form.UserDocuments.EduCertificate == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="Degree"
                  required
                  class="mt-3"
                  plain
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.EduCertificate != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.EduCertificate)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.EduCertificate)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'EduCertificate',
                      form.UserDocuments.EduCertificate
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>

            <br />

            <div class="row" v-if="getUser.RegistrationType == 2">
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Recommendation Letter from Principal Employer *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiReco"
                  @change="onFileChange9"
                  v-if="form.UserDocuments.RecommendationLetter == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="RecoLetter"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.RecommendationLetter != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.RecommendationLetter)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.RecommendationLetter)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'RecommendationLetter',
                      form.UserDocuments.RecommendationLetter
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <br />
            <div class="row" v-if="!getPFStatus">
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Declaration Letter for Non Payment of PF/ESIC from Principal
                  Employer *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiDeclr"
                  @change="onFileChange14"
                  v-if="form.UserDocuments.PFDeclaration == ''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="RecoLetter"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.PFDeclaration != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.PFDeclaration)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.PFDeclaration)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'PFDeclaration',
                      form.UserDocuments.PFDeclaration
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <br />
            <div
              class="row"
              v-if="
                getExpFlg ||
                (getUser.RegistrationType != 0 && getUser.RegistrationType != 3)
              "
            >
              <div class="col-md-4">
                <span class="ln-mar" v-if="currentLan == 'mar'"
                  >अनुभव प्रमाणपत्र अपलोड(रोजगाराचा पुरावा/ पगार स्लिप/उपस्थिती
                  कार्ड / ईएसआयसी कार्ड / पीएफ कार्ड *</span
                >
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Experience Certificate Upload (Proof of Evidence of
                  Employment/Muster Roll/Payslip/Attendance Card/ESIC Card/PF
                  Card)) *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiExp"
                  @change="onFileChange8"
                  v-if="form.UserDocuments.ExprienceCertificate == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="Experience"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.ExprienceCertificate != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.ExprienceCertificate)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.ExprienceCertificate)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'ExprienceCertificate',
                      form.UserDocuments.ExprienceCertificate
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>

            <br />
            <div class="row" v-if="getUser.RegistrationType == 3">
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Deceased Guard's ID Card *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiDID"
                  @change="onFileChange10"
                  v-if="form.UserDocuments.DeceasedID == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="DeceasedID"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserDocuments.DeceasedID != ''">
                <a
                  :href="getImgUrl2(form.UserDocuments.DeceasedID)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.DeceasedID)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2('DeceasedID', form.UserDocuments.DeceasedID)
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>

            <br />
            <div class="row" v-if="getUser.RegistrationType == 3">
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Deceased Guard's Death Certificate *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiDDth"
                  @change="onFileChangeDth"
                  v-if="form.UserDocuments.DeathCertificate == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="DeathCertificate"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.DeathCertificate != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.DeathCertificate)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.DeathCertificate)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'DeathCertificate',
                      form.UserDocuments.DeathCertificate
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>

            <br />
            <div class="row" v-if="getUser.ExServiceMan">
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Letter from D.O. for Ex-Serviceman *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiXSvc"
                  @change="onFileChange15"
                  v-if="form.UserDocuments.ExServiceManProof == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="LegalHireNOC"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.ExServiceManProof != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.ExServiceManProof)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.ExServiceManProof)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'ExServiceManProof',
                      form.UserDocuments.ExServiceManProof
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <br />
            <div
              class="row"
              v-if="
                getUser.RegistrationType == 3 &&
                (getUser.deceasedRelation == 'Other' ||
                  getUser.FirstName + getUser.MiddleName + getUser.LastName !=
                    getUser.HeirFirstName +
                      getUser.HeirMiddleName +
                      getUser.HeirLastName)
              "
            >
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Legal Hire's NOC *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiHNOC"
                  @change="onFileChange11"
                  v-if="form.UserDocuments.LegalHireNOC == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="LegalHireNOC"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.LegalHireNOC != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.LegalHireNOC)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.LegalHireNOC)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'LegalHireNOC',
                      form.UserDocuments.LegalHireNOC
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>

            <br />
            <div class="row" v-if="getUser.RegistrationType == 3">
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Final Dues Letter *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiNDL"
                  @change="onFileChange12"
                  v-if="form.UserDocuments.FinalDuesLetter == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="FinalDuesLetter"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div
                class="col-md-4"
                v-if="form.UserDocuments.FinalDuesLetter != ''"
              >
                <a
                  :href="getImgUrl2(form.UserDocuments.FinalDuesLetter)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.FinalDuesLetter)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2(
                      'FinalDuesLetter',
                      form.UserDocuments.FinalDuesLetter
                    )
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>

            <br />
            <div class="row" v-if="getUser.RegistrationType == 4">
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Court Orders *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiCrtOrd"
                  @change="onFileChange13"
                  v-if="form.UserDocuments.CourtOrder == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="CourtOrder"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserDocuments.CourtOrder != ''">
                <a
                  :href="getImgUrl2(form.UserDocuments.CourtOrder)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.CourtOrder)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2('CourtOrder', form.UserDocuments.CourtOrder)
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <!-- ----------------------------add new doc--------------------------------------------- -->
              <div class="row" v-if="!getUserGazz">
              <div class="col-md-4">
                <span style="font-size: 0.875rem" class="ln-eng"
                  >Name Change Gazzete *</span
                >
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiCrtOrd"
                  @change="onFileChange16"
                  v-if="form.UserDocuments.NameChangeProof == ''"
                  accept=".jpg, .png, .gif, .pdf, .JPG, .PGN, .GIF, .PDF"
                  v-model="NameChangeProof"
                  required
                  class="mt-3"
                  plain
                  size="sm"
                ></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserDocuments.NameChangeProof != ''">
                <a
                  :href="getImgUrl2(form.UserDocuments.NameChangeProof)"
                  target="_blank"
                >
                  <img
                    :src="getImgUrl(form.UserDocuments.NameChangeProof)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left: 0.5rem"
                  @click.stop="
                    deleteDocument2('NameChangeProof', form.UserDocuments.NameChangeProof)
                  "
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i
                    class="fa fa-trash"
                    style="font-size: 16px; color: red"
                  ></i>
                </b-button>
              </div>
            </div>
            <!-- ----------------------------end new doc------------------------------------------ -->
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2 justify-content-md-center" v-if="!getUser.LockProfile">
        <b-col md="5" sm="12" style="text-align: center">
          <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert = false"
            :variant="variant"
          >
            {{ alertText }}
          </b-alert>
        </b-col>
        <b-col md="4" sm="12" style="text-align: right">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved"
            >Next</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <!-- <p style="font-size: 17px;color:#2284ab;">Document Details</p>
        <b-row align-h="center">
            <b-col md="6" sm="12">
                <b-table show-empty head-variant="dark"
                            stacked="md"
                            bordered
                            striped
                            :items="docTbl"
                            :fields="fields"
                            style="font-size:12px"   
                >
                    <template slot="show_details" slot-scope="row">
                    </template>
                    <template slot="action" slot-scope="row">
                        <b-button size="sm" @click.stop="showImages(row.item, row.index, $event.target)" :href="row.item.link" target="_blank"
                            class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="View Document">
                            <i class="fa fa-edit" style="font-size:16px;color:blue"></i>
                        </b-button>
                        <b-button size="sm" @click.stop="deleteDocument(row.item, row.index, $event.target)" 
                            class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="Delete Document">
                            <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                        </b-button>
                    </template>
                    <template slot="row-details" slot-scope="row">
                        <b-card>
                            <span>{{row.item.description}}</span>
                        </b-card>
                    </template>
                    </b-table>
            </b-col>
        </b-row> -->

    <!-- <b-modal ref='myModalRef' id="modal1" hide-footer title="Document">
          <b-img  :src="require('imgPath')" alt="Thumbnail" />
        </b-modal> -->
    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button
          variant="danger"
          @click="modalConfirm"
          style="margin-left: 5px"
          >Delete</b-button
        >
        <b-button variant="info" @click="modalCancel" style="margin-left: 5px"
          >Cancel</b-button
        >
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import * as _ from "lodash";
import axios from "axios";

import lambda from "@/apis/lambda";
import Spinner from "vue-simple-spinner";

const _SheetJSFT = ["jpeg", "jpg", "png", "pdf"]
  .map(function (x) {
    return "." + x;
  })
  .join(",");
export default {
  components: { Spinner },
  data() {
    return {
      userId: "",
      IsNameChanged: "",
      imgPath: "",
      currentLan: "eng",
      show: true,
      Photo: null,
      Signature: null,
      Aadhaar: null,
      rationCard: null,
      dob: null,
      Caste: null,
      Degree: null,
      Experience: null,
      RecoLetter: null,
      CourtOrder: null,
      DeceasedID: null,
      LegalHireNOC: null,
      FinalDuesLetter: null,
      NameChangeProof: null,
      showDismissibleAlert: false,
      DeathCertificate: null,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false,
      docObj: {},
      docTbl: [],
      modalInfo: "",
      selecteObj: {
        Document: "",
        Path: "",
      },
      fields: [
        { key: "Document", label: "Document" },
        { key: "Path", label: "File" },
        { key: "action", label: "View" },
      ],
      form: {
        UserDocumentUpload: {
          ExprienceCertificateStatus: false,
          ExServiceManCertificateStatus: false,
          DegreeCertificateStatus: false,
          CasteCertificateStatus: false,
          DOBCertificateStatus: false,
          RationCardStatus: false,
          AdharCardStatus: false,
          ApplicantSignatureStatus: false,
          ApplicantPhotoStatus: false,
          RecoLetterStatus: false,
          CourtOrderStatus: false,
          DeceasedIDStatus: false,
          LegalHireNOCStatus: false,
          FinalDuesLetterStatus: false,
          PFDeclarationStatus: false,
          NameChangeProofStatus: false
        },
        UserDocuments: {
          PhotoPath: "",
          SignaturePath: "",
          AdharCardPath: "",
          PancardPath: "",
          RationCardPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          ExServiceManProof: "",
          ExprienceCertificate: "",
          BirthCertificate: "",
          RecommendationLetter: "",
          CourtOrder: "",
          DeceasedID: "",
          LegalHireNOC: "",
          FinalDuesLetter: "",
          PFDeclaration: "",
          DeathCertificate: "",
          NameChangeProof: "",
        },
        LoginID: "",
      },
    };
  },
  computed: {
    getUserGazz() {
      let x = this.$store.getters.getUserData;
      if (x.IsNameChanged) {
        if (  
         
          x.IsNameChanged == true || x.IsNameChanged == 'true'
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    getUserCat() {
      let x = this.$store.getters.getUserData;
      if (x.UserReligionCaste) {
        if (
          x.UserReligionCaste.CategoryID ==
          "d25679fb-92ea-434d-a0f8-65b3290c7a8b"
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    // getUserExp() {
    //   let x = this.$store.getters.getUserData;
    //   //console.log("X", x);
    //   if (x.RegistrationType) {
    //     if (x.RegistrationType == 0 || x.RegistrationType == "0") {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   } else {
    //     return true;
    //   }
    // },
    // getRegType() {
    //   let x = this.$store.getters.getUserData;

    //   if (x.RegistrationType) {
    //     return x.RegistrationType;
    //   } else {
    //     return '';
    //   }
    // },
    getUser() {
      let x = this.$store.getters.getUserData;

      if (x) {
        return x;
      } else {
        return { LockProfile: false };
      }
    },
    getPFStatus() {
      return this.$store.getters.getPFStatus;
    },
    getExpFlg() {
      return this.$store.getters.getExperienceFlag;
    },
  },
  methods: {
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    deleteDocument2(document, path) {
      //console.log(item);
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let info = "You want to delete record for:" + "\n" + document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }
        return (
          "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
          this.userId +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        return (
          "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
          this.userId +
          "/" +
          pic
        );
      }
    },
    showImages(item, index, target) {
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      let link =
        "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
        userid +
        "/" +
        item.Path;
      // this.imgPath = link;
      // this.$refs.myModalRef.show()
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onFileChange1(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiPhoto.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
        var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "UserPhoto_"+timestamp + '.'+ extn;
     // var filepath = "UserPhoto_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.PhotoPath = filepath;
            this.form.UserDocumentUpload.ApplicantPhotoStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    onFileChange2(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiSign.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
        var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "UserSignature_"+timestamp + '.'+ extn;
      //var filepath = "UserSignature_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.SignaturePath = filepath;
            this.form.UserDocumentUpload.ApplicantSignatureStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiSign.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiSign.reset();
          this.isLoading = false;
        });
    },

    onFileChange3(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiAdhr.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "UserAdharCard_"+timestamp + '.'+ extn;
      //var filepath = "UserAdharCard_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.AdharCardPath = filepath;
            this.form.UserDocumentUpload.AdharCardStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiAdhr.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiAdhr.reset();
          this.isLoading = false;
        });
    },

    onFileChange4(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiRtn.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
         var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "UserRationCard_"+timestamp + '.'+ extn;
     // var filepath = "UserRationCard_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.RationCardPath = filepath;
            this.form.UserDocumentUpload.RationCardStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiRtn.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiRtn.reset();
          this.isLoading = false;
        });
    },

    onFileChange5(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiDob.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "UserBirthCertificate_"+timestamp + '.'+ extn;
     // var filepath = "UserBirthCertificate_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.BirthCertificate = filepath;
            this.form.UserDocumentUpload.DOBCertificateStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiDob.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiDob.reset();
          this.isLoading = false;
        });
    },

    onFileChange6(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiCst.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "UserCasteCertificate_"+timestamp + '.'+ extn;
     // var filepath = "UserCasteCertificate_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.CasteCertificate = filepath;
            this.form.UserDocumentUpload.CasteCertificateStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiCst.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiCst.reset();
          this.isLoading = false;
        });
    },

    onFileChange7(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiEdu.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "UserDegreeCertificate_"+timestamp + '.'+ extn;
     // var filepath = "UserDegreeCertificate_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.EduCertificate = filepath;
            this.form.UserDocumentUpload.DegreeCertificateStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiEdu.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiEdu.reset();
          this.isLoading = false;
        });
    },

    onFileChange8(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiExp.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
         var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "UserExprienceCertificate_"+timestamp + '.'+ extn;
     // var filepath = "UserExprienceCertificate_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UserDocuments.ExprienceCertificate = filepath;
            this.form.UserDocumentUpload.ExprienceCertificateStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiExp.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiExp.reset();
          this.isLoading = false;
        });
    },

    onFileChange9(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiReco.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "RecommendationLetter_"+timestamp + '.'+ extn;
     // var filepath = "RecommendationLetter_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.RecommendationLetter = filepath;
            this.form.UserDocumentUpload.RecoLetterStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiReco.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiReco.reset();
          this.isLoading = false;
        });
    },

    onFileChange10(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiDID.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "DeceasedID_"+timestamp + '.'+ extn;
      //var filepath = "DeceasedID_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.DeceasedID = filepath;
            this.form.UserDocumentUpload.DeceasedIDStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiDID.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiDID.reset();
          this.isLoading = false;
        });
    },

    onFileChange11(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiHNOC.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "LegalHireNOC_"+timestamp + '.'+ extn;
      //var filepath = "LegalHireNOC_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.LegalHireNOC = filepath;
            this.form.UserDocumentUpload.LegalHireNOCStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiHNOC.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiHNOC.reset();
          this.isLoading = false;
        });
    },

    onFileChange12(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiNDL.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
        var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "FinalDuesLetter_"+timestamp + '.'+ extn;
    //  var filepath = "FinalDuesLetter_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.FinalDuesLetter = filepath;
            this.form.UserDocumentUpload.FinalDuesLetterStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiNDL.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiNDL.reset();
          this.isLoading = false;
        });
    },

    onFileChange15(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiXSvc.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "DOLetter_"+timestamp + '.'+ extn;
     // var filepath = "DOLetter_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.ExServiceManProof = filepath;
            this.form.UserDocumentUpload.ExServiceManCertificateStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiXSvc.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiXSvc.reset();
          this.isLoading = false;
        });
    },

    onFileChange13(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiCrtOrd.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
        var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "CourtOrder_"+timestamp + '.'+ extn;
     // var filepath = "CourtOrder_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.CourtOrder = filepath;
            this.form.UserDocumentUpload.CourtOrderStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiCrtOrd.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiCrtOrd.reset();
          this.isLoading = false;
        });
    },

    onFileChange14(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiDeclr.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
          var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "PFDeclaration_"+timestamp + '.'+ extn;
     // var filepath = "PFDeclaration_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.PFDeclaration = filepath;
            this.form.UserDocumentUpload.PFDeclarationStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiDeclr.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiDeclr.reset();
          this.isLoading = false;
        });
    },
    onFileChange16(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiHNOC.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "NameChangeProof_"+timestamp + '.'+ extn;
     // var filepath = "NameChangeProof_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.NameChangeProof = filepath;
            this.form.UserDocumentUpload.NameChangeProofStatus = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.fiHNOC.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiHNOC.reset();
          this.isLoading = false;
        });
    },

    onFileChangeDth(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiDDTH.reset();
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
       var now = new Date();
         var timestamp = now.getFullYear() + 
               ('0' + (now.getMonth() + 1)).slice(-2) + 
               ('0' + now.getDate()).slice(-2) + '_' +
               ('0' + now.getHours()).slice(-2) + 
               ('0' + now.getMinutes()).slice(-2) + 
               ('0' + now.getSeconds()).slice(-2);
      var filepath = "DeathCertificate_"+timestamp + '.'+ extn;
      //var filepath = "DeathCertificate_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then((response) => {
          let signedUrl = response;
          var options = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": files[0].type,
            },
          };
          return axios.put(signedUrl, files[0], options);
        })
        .then((res) => {
          if (res.status == 200) {
            this.form.UserDocuments.DeathCertificate = filepath;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs.FIDDth.reset();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiDeclr.reset();
          this.isLoading = false;
        });
    },

    onSubmit(evt) {
      this.showDismissibleAlert = false;
      evt.preventDefault();
      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      let promise = apis.saveDocumentPath(this.form);

      promise
        .then((response) => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.loadImageList();
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.$refs.fiPhoto.reset();
      this.$refs.fiSign.reset();
      this.$refs.fiAdhr.reset();
      this.$refs.fiRtn.reset();
      this.$refs.fiDob.reset();
      this.$refs.fiCst.reset();
      this.$refs.fiEdu.reset();
      this.$refs.fiExp.reset();
      this.$refs.fiReco.reset();
      this.$refs.fiDID.reset();
      this.$refs.fiHNOC.reset();
      this.$refs.fiNDL.reset();
      this.$refs.fiCrtOrd.reset();
      this.$refs.fiXSvc.reset();
      this.$refs.fiDeclr.reset();
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },

    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      let promise = apis.saveDocumentPath(this.form);

      promise
        .then((response) => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            if (this.docTbl.length > 0) {
              this.loadImageList();
            }
            switch (this.selecteObj.Document) {
              case "PhotoPath":
                this.$refs.fiPhoto.reset();
                break;
              case "SignaturePath":
                this.$refs.fiSign.reset();
                break;
              case "AdharCardPath":
                this.$refs.fiAdhr.reset();
                break;
              case "PancardPath":
                break;
              case "RationCardPath":
                this.$refs.fiRtn.reset();
                break;
              case "CasteCertificate":
                this.$refs.fiCst.reset();
                break;
              case "EduCertificate":
                this.$refs.fiEdu.reset();

                break;
              case "ExServiceManProof":
                this.$refs.fiXSvc.reset();
                break;

              case "ExprienceCertificate":
                this.$refs.fiExp.reset();
                break;
              case "BirthCertificate":
                this.$refs.fiDob.reset();
                break;
              case "DeathCertificate":
                this.$refs.FIDDth.reset();
                break;
            }
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },
  

    loadImageList() {
      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      //   var filename =   this.Photo.name;
      let promise = apis.readDocumentPath(userid);
      this.docTbl = [];
      promise
        .then((response) => {
          if (response.status == 200) {
            this.form.UserDocuments = response.body;
            // console.log('Documents', response.body);
            this.docObj = response.body;
            for (var key in this.docObj) {
              if (this.docObj.hasOwnProperty(key)) {
                if (this.docObj[key]) {
                  if (this.docObj[key] != "" && this.docObj[key] != null) {
                    let link =
                      "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
                      userid +
                      "/" +
                      this.docObj[key];

                    this.docTbl.push({
                      Document: key,
                      Path: this.docObj[key],
                      link: link,
                    });
                  }
                }
                //console.log(key + " -> " + this.docObj[key]);
              }
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
  },
  async mounted() {
       
    var userinfo = this.$store.getters.loggedUser;
    var n = 1;

    while (Object.keys(userinfo).length == 0 && n < 6) {
      await this.sleep(10000); //userinfo is not loaded wait till 10 seconds
      userinfo = this.$store.getters.getUserData;
      n = n + 1;
    }
    this.userId = userinfo.UserId;
    this.loadImageList();

    
    let promiseU = apis.ReadUserDetail(userinfo.UserId);

    promiseU
      .then(response => {
        if (response.status == 200) {
          
          this.IsNameChanged = response.body.IsNameChanged;
          //console.log(this.IsNameChanged);    
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  


  },
};
</script>

<style scoped>
img {
  width: 50px;
  border-radius: 2px;
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);
  transition: width 1s;
}
</style>




// WEBPACK FOOTER //
// src/components/RegistrationDetails/FormUploads.vue